import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconNgarko = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	width: "14px",
	height: "14px",
	fill: "#323338",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 16.6",
	style: { enableBackground: "new 0 0 14 16.6" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7429_00000029032457934157017360000010140754146058612150_",
		d: "M2.4,6.6H4v5c0,0.6,0.4,1,1,1h4 c0.6,0,1-0.4,1-1v-5h1.6c0.6,0,1-0.4,1-1c0-0.3-0.1-0.5-0.3-0.7L7.7,0.3c-0.4-0.4-1-0.4-1.4,0L1.7,4.9c-0.4,0.4-0.4,1,0,1.4 C1.9,6.5,2.1,6.6,2.4,6.6z M0,15.6c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1C0.4,14.6,0,15,0,15.6z"
	})
});
export { SvgIconNgarko as ReactComponent };
